module.exports = __webpack_public_path__ + "img/tg_01 (5).ecc913a0.jpg";